var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payroll_Concept",
    "data-name": "Payroll Concept"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4,37.49A2.55,2.55,0,1,0,23.94,40,2.55,2.55,0,0,0,21.4,37.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,37.49A2.55,2.55,0,1,0,14.55,40,2.55,2.55,0,0,0,12,37.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.65,37.49c-1.13-2.32-1.76-10.82-1.76-10.82l-5.19-.1V37.81a1.67,1.67,0,0,1-.21,1.13,1.34,1.34,0,0,1-1.26.86,1.37,1.37,0,0,1-1.37-1.37v-.27c0-.08,0-.17,0-.25V27.73a1.85,1.85,0,0,0-1.69-1.34c-.84,0-2.13,0-2.13,0V21H31.68v5.4l-4,0V15.71c0-1.11-.66-3.47-1.82-3.47H15c-1.19,0-1.83,2.63-1.83,4V27.09s-2.24,1.05-2.59,1.75a17.68,17.68,0,0,0-.58,3.6,7.73,7.73,0,0,0,1.44,15.32h20a7.65,7.65,0,0,0,4.83-1.7h20.1C53.71,45.5,49.77,39.81,48.65,37.49ZM16.27,14.9h8.27v8.31H16.27ZM31.38,44.82h-20a4.79,4.79,0,0,1,0-9.58h20a4.79,4.79,0,1,1,0,9.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.79,37.49A2.55,2.55,0,1,0,33.33,40,2.55,2.55,0,0,0,30.79,37.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.3e056928355a4c438a152975eeb3874a.svg";
export { ForwardRef as ReactComponent };